/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs */

const en_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task accuracy`)
};

const ar_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دقة المهام`)
};

const bn_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টাস্ক নির্ভুলতা`)
};

const de_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabengenauigkeit`)
};

const es_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisión de la tarea`)
};

const fr_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précision de la tâche`)
};

const pt_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisão da tarefa`)
};

const zh_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任务准确性`)
};

const tr_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görev doğruluğu`)
};

const ru_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точность задачи`)
};

const pl_svc_ai_agent_development_work_0_metric_0_label = /** @type {(inputs: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokładność zadania`)
};

/**
* | output |
* | --- |
* | "Task accuracy" |
*
* @param {Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_work_0_metric_0_label = /** @type {((inputs?: Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Work_0_Metric_0_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "de") return de_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "es") return es_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_work_0_metric_0_label(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_work_0_metric_0_label(inputs)
	return en_svc_ai_agent_development_work_0_metric_0_label(inputs)
});
export { svc_ai_agent_development_work_0_metric_0_label as "svc_ai-agent-development_work_0_metric_0_label" }